export const JRA_ITEMS_TAB_ID = "JRA-Details";